import React, {
  RefObject,
  useEffect,
} from 'react';
import Table from 'core/components/VirtualTable';
import {
  billingEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import {
  getBillingChargesData,
} from 'pages/Dashboard/pages/Billing/api';
import {
  cptColumns,
} from 'pages/Dashboard/pages/Billing/ChargeMaster/columns';
import {
  ChargeMasterDTO,
} from 'dtos';
import {
  normalizeCPTPrice,
} from 'pages/Dashboard/pages/Billing/helpers';

type Props = {
  searchQuery?: string;
  tableInstanceRef?: RefObject<VirtualTableInstance>;
};

export default function CptCodesOverview({
  searchQuery = '',
  tableInstanceRef,
}: Props) {
  useEffect(() => {
    const unsubscribeFromChange = billingEventChannel.on('onPricesChanged', () => {
      tableInstanceRef?.current?.refetch?.();
    });

    return () => {
      unsubscribeFromChange();
    };
  }, []);

  return (
    <div className="flex flex-1 w-full h-full overflow-y-hidden">
      <Table<ChargeMasterDTO>
        instanceRef={tableInstanceRef}
        columns={cptColumns}
        defaultPagination={{
          pageSize: 25,
          pageIndex: 0,
        }}
        getData={getBillingChargesData}
        dataKey="cpt-codes-table"
        queryParams={{ searchQuery }}
        onRowClick={(table, row) => {
          billingEventChannel.emit('onPriceDialogOpen', {
            price: normalizeCPTPrice(row.original),
            type: 0,
          });
        }}
        classes={{
          header: 'px-4',
          scrollContainer: 'justify-center items-center',
          outerRow: '!w-[calc(100%-16px)] left-4',
          row: '!items-start',
        }}
      />
    </div>
  );
}
